module.exports = __webpack_public_path__ + "static/media/down-arrow.2a36f418.svg";